import { LandingPageTemplate } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type LandingPageTemplatesState = {
  selected: Array<number>;
  query: string;
  names: { [key: number]: string };
};

const initialState: LandingPageTemplatesState = {
  selected: [],
  query: '',
  names: {},
};

export const landingPageTemplatesSlice = createSlice({
  name: 'landing-page-templates',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<LandingPageTemplate>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<LandingPageTemplate[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((emailT) => emailT.id));
      action.payload.forEach((emailT) => (state.names[emailT.id] = emailT.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setQuery } = landingPageTemplatesSlice.actions;

export const getSelectedLandingPageTemplates = (state: RootState) => state.landingPageTemplates.selected;

export const getSelectedNamedLandingPageTemplates = (state: RootState) =>
  Object.entries(state.landingPageTemplates.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getLandingPageTemplatesQuery = (state: RootState) => state.landingPageTemplates.query;

export default landingPageTemplatesSlice.reducer;
